import styled from "@emotion/styled";

/*
An open window and an announced one are told apart by weight as well as colour,
so the difference survives a colourblind reader or a washed-out projector.

Sized for a phone first and widened at the 768px breakpoint the rest of the
admin site uses: the message is a full sentence carrying two dates.
 */
export const BannerStrip = styled.div<{ active: boolean }>`
    font-family: "Helvetica", Arial, sans-serif;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0.75rem 0.875rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-bottom: 1px solid #dee2e6;
    background-color: ${({ active }) => (active ? "#163b5d" : "#e0f2fe")};
    color: ${({ active }) => (active ? "#ffffff" : "#334155")};
    font-weight: ${({ active }) => (active ? 700 : 400)};

    @media (min-width: 768px) {
        align-items: center;
        gap: 1rem;
        padding: 0.75rem 1.25rem;
        font-size: 0.938rem;
    }
`;

/* The sentence carries a date, so it has to be allowed to wrap. */
export const BannerMessage = styled.span`
    flex: 1;
    overflow-wrap: anywhere;
`;

export const DismissButton = styled.button<{ active: boolean }>`
    flex-shrink: 0;
    background: none;
    border: none;
    padding: 0 0.25rem;
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer;
    color: ${({ active }) => (active ? "#dee2e6" : "#4b5563")};

    &:hover {
        color: ${({ active }) => (active ? "#ffffff" : "#163b5d")};
    }
`;
